import { useMemo } from 'react';
import {
  registerAnswerFormatter,
  registerFieldComponent,
  StepFormApp,
  type AppSettings,
  type FormSchema,
} from '@stepform';
import { buildSchema } from './schema';
import { ExtractivesDisplayService } from './displayService';
import { ExtractivesValidationService } from './validationService';
import {
  DropDownDependantField,
  RadioDependantField,
} from './components/DependantFields';
import { ExtractivesReviewStep } from './components/ExtractivesReviewStep';
import { NameField } from './components/NameField';
import { NzbnField } from './components/NzbnField';
import {
  formatNotifiableEventsAnswer,
  NotifiableEventsField,
} from './components/NotifiableEventsField';
import {
  formatSplitQuantityAnswer,
  SplitQuantityField,
} from './components/SplitQuantityField';

registerFieldComponent('Name', NameField);
registerFieldComponent('NZBN', NzbnField);
registerFieldComponent('SplitQuantity', SplitQuantityField);
registerFieldComponent('NotifiableEvents', NotifiableEventsField);
registerFieldComponent('DropDownDependant', DropDownDependantField);
registerFieldComponent('RadioDependant', RadioDependantField);
registerAnswerFormatter('SplitQuantity', (question) => formatSplitQuantityAnswer(question.answer));
registerAnswerFormatter('NotifiableEvents', (question) =>
  formatNotifiableEventsAnswer(question.answer)
);
registerAnswerFormatter('Name', (question) => String(question.answer ?? ''));

const customStepComponents = {
  ExtractivesReview: ExtractivesReviewStep,
};

export function ExtractivesApp({ settings }: { settings: AppSettings }) {
  const schema = useMemo<FormSchema>(
    () => buildSchema(settings.fieldOptions),
    [settings.fieldOptions]
  );

  return (
    <StepFormApp
      settings={{
        // Matches the 'step-$StepNumber!' route on ExtractivesFormPageController
        stepUrlPrefix: 'step-',
        submitButtonLabel: 'Submit',
        continueAlwaysEnabled: true,
        stepIndicatorStyle: 'enhanced',
        hideStepTitlesWithQuestions: true,
        ...settings,
      }}
      schema={schema}
      ValidationServiceClass={ExtractivesValidationService}
      DisplayServiceClass={ExtractivesDisplayService}
      customStepComponents={customStepComponents}
    />
  );
}
